import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  Paper,
} from "@mui/material";
import { Visibility, VisibilityOff, LockReset } from "@mui/icons-material";
import { useChangePasswordMutation } from "../services/auth";

export default function ChangePassword() {
	const [changePassword, { isLoading }] = useChangePasswordMutation();
  const [values, setValues] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
    showCurrent: false,
    showNew: false,
    showConfirm: false,
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (prop) => (e) => {
    setValues({ ...values, [prop]: e.target.value });
  };

  const handleToggle = (prop) => () => {
    setValues({ ...values, [prop]: !values[prop] });
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!values.currentPassword || !values.newPassword || !values.confirmPassword) {
      return setError("Vui lòng nhập đầy đủ dữ liệu.");
    }

    if (values.newPassword.length < 6) {
      return setError("Mật khẩu tối thiểu 6 ký tự.");
    }

    if (values.newPassword !== values.confirmPassword) {
      return setError("Mật khẩu mới không khớp.");
    }

    try {
      const result = await changePassword({currentPassword: values.currentPassword, newPassword: values.newPassword}).unwrap();
			let strResult = result;
			if(typeof result === "string")
				strResult = JSON.parse(result);

			if(strResult == "wrong")
				setError("Sai mật khẩu hiện tại.");
			else if(strResult == "ok")
      	setSuccess("Đã thay đổi mật khẩu thành công!");
			else
				setError("Chưa thể đổi mật khẩu.");
    } catch (err) {
      setError("Chưa thể đổi mật khẩu.");
      console.error(err);
    }
    // console.log("Password updated:", values);
    // setSuccess("Password changed successfully!");
    setValues({
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      showCurrent: false,
      showNew: false,
      showConfirm: false,
    });
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        bgcolor: "background.default",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          width: "100%",
          maxWidth: 400,
          borderRadius: 3,
        }}
      >
        <Box textAlign="center" sx={{ mb: 3 }}>
          <LockReset sx={{ fontSize: 48, color: "primary.main" }} />
          <Typography variant="h5" sx={{ mt: 1 }}>
            Đổi Mật Khẩu
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Cập nhật mật khẩu tài khoản của bạn bên dưới.
          </Typography>
        </Box>

        <form onSubmit={handleSubmit}>
          {/* Current Password */}
          <TextField
            fullWidth
            type={values.showCurrent ? "text" : "password"}
            label="Mật Khẩu Hiện Tại"
            variant="outlined"
            margin="normal"
            value={values.currentPassword}
            onChange={handleChange("currentPassword")}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleToggle("showCurrent")} edge="end">
                    {values.showCurrent ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          {/* New Password */}
          <TextField
            fullWidth
            type={values.showNew ? "text" : "password"}
            label="Mật Khẩu Mới"
            variant="outlined"
            margin="normal"
            value={values.newPassword}
            onChange={handleChange("newPassword")}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleToggle("showNew")} edge="end">
                    {values.showNew ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          {/* Confirm Password */}
          <TextField
            fullWidth
            type={values.showConfirm ? "text" : "password"}
            label="Xác Nhận Mật Khẩu Mới"
            variant="outlined"
            margin="normal"
            value={values.confirmPassword}
            onChange={handleChange("confirmPassword")}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleToggle("showConfirm")} edge="end">
                    {values.showConfirm ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          {error && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {error}
            </Typography>
          )}
          {success && (
            <Typography color="success.main" variant="body2" sx={{ mt: 1 }}>
              {success}
            </Typography>
          )}

          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            sx={{ mt: 3, py: 1 }}
          >
            Đổi Mật Khẩu
          </Button>
        </form>
      </Paper>
    </Box>
  );
}
